type Props = {
    mentorName: string | null;
    bio: string | null;
};

const MenteeMyMentorAbout = ({ mentorName, bio }: Props) => {
    const displayName = mentorName?.trim() || 'your mentor';
    const trimmed = bio?.trim() || '';

    return (
        <>
            <div className="col-md-6">
                <div className="card border-0 shadow-sm rounded-3 h-100">
                    <div className="card-header bg-white border-bottom border-light-subtle p-3">
                    <h6 className="fw-bold mb-0 text-dark">About {displayName}</h6>
                    </div>
                    <div className="card-body p-3">
                    {trimmed ? (
                        <p className="text-secondary small mb-3">{trimmed}</p>
                    ) : (
                        <p className="text-secondary small">{displayName} hasn&apos;t added a bio yet</p>
                    )}
                    </div>
                </div>
            </div>

            
        </>
    );
};

export default MenteeMyMentorAbout;
